import type { UserModel } from "~/models/User.model";
import { useAuthStore } from "~/stores/auth";
export default defineNuxtRouteMiddleware(async (to) => {
  // /login and /register are prerendered at build time, where there is no
  // request and therefore no session. Calling getUser() then would fire an
  // unauthenticated API request during the build — slow at best, a failed
  // prerender at worst — to decide something that is always "guest".
  if (import.meta.prerender) return;

  useAuthStore().setAuthenticationRequired(true);
  const $localePath = useLocalePath();
  const authStore = useAuthStore();
  const user: UserModel = await authStore.getUser();
  if (user.id && !to.name?.toString().startsWith("register") && !to.name?.toString().startsWith("create-password")) {
    // A signed-in-but-incomplete account (no nickname yet — e.g. the wizard was
    // abandoned right after step 1) must NOT be bounced onward via redirect_to:
    // the API's own oauth/authorize check rejects an incomplete profile the
    // same way and sends the browser straight back to this page, an infinite
    // loop between here and the service the user came from. Let them finish
    // their profile instead — register.vue's own onMounted already resumes at
    // step 2 for a signed-in user with no nickname, so just route it there.
    if (!user.nickname) {
      return navigateTo({ path: $localePath("/register"), query: to.query });
    }
    // If there's a redirect_to param, honour it (user came from another platform)
    const redirectTo = to.query.redirect_to as string | undefined;
    if (redirectTo) {
      return navigateTo(redirectTo, { external: true });
    }
    return navigateTo($localePath("/account/dashboard"));
  }
});
